export default __webpack_public_path__ + "static/media/15.bb7629de.jpg";